import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Button, Form, Table } from "react-bootstrap";
import { Flag } from "react-feather";
import getOnboardingStages from "../../utils/onboardingStages";
import Spinner from 'react-bootstrap/Spinner';

const { REACT_APP_BACKEND_URL } = process.env;


const OnboardingAreasOfExpertise = ({stage, token, data}) => {
  var initialValues = {
    areasOfExpertise:[], 
    ageLowerBound: data.ageLowerBound == null ? "" : data.ageLowerBound,
    ageUpperBound: data.ageUpperBound == null ? "" : data.ageUpperBound
  };

  if (data && data.areasOfExpertise)
  {
    for (var i = 0; i < data.areasOfExpertise.length; i++)
    {
      if (data.areasOfExpertise[i].ageLowerBound == null)
      {
        data.areasOfExpertise[i].ageLowerBound = "";
      }
      if (data.areasOfExpertise[i].ageUpperBound == null)
      {
        data.areasOfExpertise[i].ageUpperBound = "";
      }

      data.areasOfExpertise[i].editAges = false;

      if (data.areasOfExpertise[i].isActive)
      {
        if (data.areasOfExpertise[i].ageLowerBound !== initialValues.ageLowerBound)
        {
          data.areasOfExpertise[i].editAges = true;
        }
      }

      if (data.areasOfExpertise[i].isActive)
      {
        if (data.areasOfExpertise[i].ageUpperBound !== initialValues.ageUpperBound)
        {
          data.areasOfExpertise[i].editAges = true;
        }
      }
    
      initialValues.areasOfExpertise.push(data.areasOfExpertise[i]);
    }
  }

  let onboardingStages = getOnboardingStages(data.preferences);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={Yup.object().shape({
        ageLowerBound: Yup.number()
          .min(0, "0 - 120")
          .max(120, "0 - 120"),
        ageUpperBound: Yup.number()
          .min(0, "Age upper bound must be a positive number")
          .max(120, "0 - 120")
          .test(
            "is-greater",
            "Invalid age range",
            function (value) {
              const { ageLowerBound } = this.parent;
              return value === undefined || ageLowerBound === undefined || value >= ageLowerBound;
            }
          ),
        areasOfExpertise: Yup.array().of(
          Yup.object().shape({
            editAges: Yup.boolean(),
            isActive: Yup.boolean(),
            ageLowerBound: Yup.number().min(0, "0 - 120").max(120, "0 - 120"),
            ageUpperBound: Yup.number()
              .min(0, "0 - 120")
              .max(120, "0 - 120")
              .test(
                "is-greater",
                "Invalid age range",
                function (value) {
                  const { ageLowerBound } = this.parent;
                  return value === undefined || ageLowerBound === undefined || value >= ageLowerBound;
                }
              )
          })
        )
      })}
      onSubmit={async (values, { setErrors, setStatus, resetForm, setSubmitting }) => {
        try {
          var formData = new FormData();
          formData.append("data", new Blob([JSON.stringify(
            {
              ageLowerBound: values.ageLowerBound,
              ageUpperBound: values.ageUpperBound,
              areasOfExpertise: values.areasOfExpertise
            })], {
              type: "application/json"
          }));

          // No files, but do it the same way so we can keep the backend consistent

          const requestMetadata = {
            method: 'POST',
            body: formData
          };

          const res = await fetch(REACT_APP_BACKEND_URL + "onboarding/" + stage + "/" + token, requestMetadata);

          if (res.status >= 200 && res.status <= 299)
          {
            setStatus({success: true})

            window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) + 1] + "/" + token
          }
          else if (res.status === 400)
          {
            setStatus({ success: false });
            alert("Unable to submit; please disable any ad blockers and/or antivirus software and try again. If the problem persists, using a different browser may help.");
            setSubmitting(false);
          }
          else
          {
            throw Error(res.statusText);
          }
        } catch (error) {
          const message = "Something went wrong; please try again";

          setStatus({ success: false });
          alert(message);
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        status,
        touched,
        values,
        getFieldProps,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label style={{fontWeight: "bold"}}>Areas of Expertise
            <br /><span style={{fontSize: '0.9em', fontWeight: "normal"}}><Flag style={{height: "16px", width: "16px", color: "#2B7A78"}} /> Leave age ranges blank for all ages / no bounds</span>
            </Form.Label>
            <br />
            <Table striped size="sm">
              <thead>

              </thead>
              <tbody>
                <tr>
                  <td style={{width: "220px"}}>Age Range Treated
                  </td>
                  <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                  <td style={{verticalAlign: "top", width: "80px"}}>
                    <Form.Control type="number" style={{textAlign: "right"}}
                      {...getFieldProps('ageLowerBound')}
                      isInvalid={Boolean(touched.ageLowerBound && errors.ageLowerBound)}
                      onChange={(e) => {
                        handleChange(e);
                        for (var i = 0; i < values.areasOfExpertise.length; i++)
                        {
                          if (values.areasOfExpertise[i].isActive && !values.areasOfExpertise[i].editAges)
                          {
                            setFieldValue(`areasOfExpertise[${i}].ageLowerBound`, e.target.value);
                          }
                        }
                      }}
                    />
                    {!!touched.ageLowerBound && (
                      <Form.Control.Feedback type="invalid">
                        {errors.ageLowerBound}
                      </Form.Control.Feedback>
                    )}
                  </td>
                  <td>-</td>
                  <td style={{verticalAlign: "top", width: "80px"}}>
                    <Form.Control type="number"
                      {...getFieldProps('ageUpperBound')}
                      isInvalid={Boolean(touched.ageUpperBound && errors.ageUpperBound)}
                      onChange={(e) => {
                        handleChange(e);
                        for (var i = 0; i < values.areasOfExpertise.length; i++)
                        {
                          if (values.areasOfExpertise[i].isActive && !values.areasOfExpertise[i].editAges)
                          {
                            setFieldValue(`areasOfExpertise[${i}].ageUpperBound`, e.target.value);
                          }
                        }
                      }}
                    />
                    {!!touched.ageUpperBound && (
                      <Form.Control.Feedback type="invalid">
                        {errors.ageUpperBound}
                      </Form.Control.Feedback>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table striped size="sm">
              <thead>
                <tr>
                  <th style={{width: "220px"}}>Description</th>
                  <th colSpan={4}>Edit Age Range</th>
                </tr>
              </thead>
              <tbody>
                {values.areasOfExpertise.map((areaOfExpertise, index) => (
                    <tr key={index}>
                      <td style={{paddingBottom: "0px"}}>
                       <Form.Label>
                          <Form.Check style={{display: "inline"}}
                            onChange={(e) => {
                              handleChange(e);
                              if (e.target.checked)
                              {
                                setFieldValue(`areasOfExpertise[${index}].ageLowerBound`, values.ageLowerBound);
                                setFieldValue(`areasOfExpertise[${index}].ageUpperBound`, values.ageUpperBound);
                              }
                              else
                              {
                                setFieldValue(`areasOfExpertise[${index}].editAges`, false);
                              }
                            }}
                            onBlur={handleBlur}
                            checked={areaOfExpertise.isActive}
                            name={`areasOfExpertise[${index}].isActive`}
                          />
                          &nbsp;&nbsp;
                          {areaOfExpertise.description}
                        </Form.Label>
                      </td>
                      <td style={{verticalAlign: "middle", paddingBottom: "0px"}}>
                        {areaOfExpertise.isActive &&
                       <Form.Label>
                          <Form.Check
                            onChange={(e) => {
                              handleChange(e);
                              setFieldValue(`areasOfExpertise[${index}].ageLowerBound`, values.ageLowerBound);
                              setFieldValue(`areasOfExpertise[${index}].ageUpperBound`, values.ageUpperBound);
                            }}
                            onBlur={handleBlur}
                            checked={areaOfExpertise.editAges}
                            name={`areasOfExpertise[${index}].editAges`}
                          />
                        </Form.Label>
                        }
                      </td>
                      { areaOfExpertise.editAges ?
                      <>
                      <td style={{verticalAlign: "middle", width: "80px"}}>
                        <Form.Control type="number" style={{ textAlign: "right"}}
                          {...getFieldProps(`areasOfExpertise[${index}].ageLowerBound`)}
                          isInvalid={Boolean(touched.areasOfExpertise?.[index]?.ageLowerBound && errors.areasOfExpertise?.[index]?.ageLowerBound)}
                        />
                        {!!touched.areasOfExpertise?.[index]?.ageLowerBound && (
                          <Form.Control.Feedback type="invalid">
                            {errors.areasOfExpertise?.[index]?.ageLowerBound}
                          </Form.Control.Feedback>
                        )}
                      </td>
                      <td>-</td>
                      <td style={{verticalAlign: "middle", width: "80px"}}>
                        <Form.Control type="number"
                          {...getFieldProps(`areasOfExpertise[${index}].ageUpperBound`)}
                          isInvalid={Boolean(touched.areasOfExpertise?.[index]?.ageUpperBound && errors.areasOfExpertise?.[index]?.ageUpperBound)}
                        />
                        {!!touched.areasOfExpertise?.[index]?.ageUpperBound && (
                          <Form.Control.Feedback type="invalid">
                            {errors.areasOfExpertise?.[index]?.ageUpperBound}
                          </Form.Control.Feedback>
                        )}
                      </td>
                      </>
                      : (areaOfExpertise.isActive ?
                      <>
                        <td style={{textAlign: "right", width: "80px"}}><span className="text-muted" style={{paddingRight: "10px"}}>{areaOfExpertise.ageLowerBound}</span></td>
                        <td>-</td>
                        <td style={{width: "80px"}}><span className="text-muted">{areaOfExpertise.ageUpperBound}</span></td>
                      </>
                      : <td colSpan={3}></td>)
                      } 
                    </tr>
                ))}
                </tbody>
            </Table>
          </Form.Group>
          <br />
          {isSubmitting ?
          <div className="text-center">
             <br />
            <Spinner size="sm" animation="border" />
          </div>
          :
          <>
            <div className="text-center mt-3 float-start">
              <Button size="lg" className="btn-secondary" onClick={() => {window.location = "/onboarding/" + onboardingStages[onboardingStages.indexOf(stage) - 1] + "/" + token}}>Back</Button>
            </div>
            <div id="submitButton" className="text-center mt-3 float-end">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}  // Don't check touched, otherwise you end up with this button disabled for, e.g. a peer reference first name missing that has never been touched, so it's not in red; let them click this to touch everything
              >
                Save and Continue
              </Button>
            </div>
          </>
          }
          <br /><br /><br />
          {
            Object.keys(errors).length > 0 && Object.keys(touched).length > 0 &&
            <div className="text-center mt-3"><span className="invalid-feedback" style={{display: "inline-block"}}>Please correct the errors above before moving forward</span></div>
          }
        </Form>
      )}
    </Formik>
  );
}

export default OnboardingAreasOfExpertise;
